import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HanselMaterialModule } from '../material.module';
import { CustomMaterialComponentsModule } from '../custom-material-components/custom-material-components.module';
import { CoreRoutingModule } from './core-routing.module';
import { HeaderComponent } from './header/header.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AppSelectorComponent } from './sidebar/app-selector/app-selector.component';
import { EnvironmentSwitcherComponent } from './sidebar/environment-switcher/environment-switcher.component';
import { SharedModule } from '../shared/shared.module';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { OverviewComponent } from '../overview/overview.component';
import { redirectToCeComponent } from './redirecting-to-netcore-ce/redirect-to-ce.component';
import { CustomerExperienceRequestAccessComponent } from './customer-experience-request-access/customer-experience-request-access.component';
import { SwitchPanelComponent } from './switch-panel/switch-panel.component';
import { OnsiteJourneyComponent } from './onsite-journey/onsite-journey.component';

@NgModule({
  imports: [
    CommonModule,
    CoreRoutingModule,
    HanselMaterialModule,
    CustomMaterialComponentsModule,
    FormsModule,
    SharedModule,
    IconSpriteModule,
  ],
  declarations: [HeaderComponent, NotFoundComponent, SidebarComponent, NotFoundComponent,
    AppSelectorComponent, EnvironmentSwitcherComponent, OverviewComponent, SwitchPanelComponent, redirectToCeComponent, CustomerExperienceRequestAccessComponent, OnsiteJourneyComponent],
  exports: [
    RouterModule,
    HeaderComponent,
    SidebarComponent
  ],
  providers: [AuthGuardService],
  entryComponents: [
    SwitchPanelComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule { }
